import Quote from "../../../atoms/text/Quote";
import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../../styles/cssinjs/helpers/variables.js";

export default function CustomerReviewBlock({ data, className, hasQuote }) {
  const appMode = process.env.APP_MODE;
  const link = data?.btns[0]?.href?.[appMode] || data?.btns[0]?.href;
  return (
    <section className={`container bg-light ${className}`}>
      <h2 className="md:text-left text-lg lg:mb-4 md:mb-3">{data.title}</h2>
      <article>
        <figure className="md:text-center">
          <img
            src={data.images.src}
            alt={data.images.alt}
            width={data.images.dimensions[0]}
            height={data.images.dimensions[1]}
            loading="lazy"
          />
        </figure>
        <blockquote className="fs-italic lg:mb-1.5 md:mb-2">
          <i>{hasQuote ? <Quote /> : ""}</i>
          {data.quote}
        </blockquote>
        <cite>{data.cite}</cite>
        <div className="lg:mt-8 md:mt-5 lg:mb-2 md:mb-2.5">
          <a
            href={link}
            className="btn-primary btn-lg lg:mr-5 md:mb-2.5 md:w-100"
          >
            <span>{data.btns[0].text}</span>
          </a>
          <a href={data.btns[1].href} className="btn-secondary btn-lg md:w-100">
            <span>{data.btns[1].text}</span>
          </a>
        </div>
        <p className="text-xs text-light-grayish-blue lg:maxw-md">
          {data.note}
        </p>
      </article>
      <style jsx>{`
        article {
          position: relative;
        }
        section {
          padding: 80px 60px 40px;
          border-radius: 8px;
        }
        figure {
          flex-basis: 300px;
          flex-shrink: 0;
        }
        img {
          width: auto;
        }
        blockquote {
          position: relative;
          font-size: ${font.size.lg[1]};
          line-height: ${font.size.lg[3]};
          color: ${colors.primitive.black[900]};
        }
        cite {
          font-size: ${font.size.md[3]};
          line-height: ${font.size.lg[3]};
          color: ${colors.primitive.black[800]};
        }

        @media (max-width: ${viewport.tablet.sm}) {
          h2 {
            font-size: ${font.size.md[3]};
            line-height: ${font.size.lg[1]};
          }
          i {
            display: block;
            margin-bottom: 16px;
          }
          i :global(svg) {
            height: 18px;
          }
          section {
            padding: 20px;
          }
          blockquote {
            font-size: ${font.size.md[3]};
            line-height: ${font.size.lg[1]};
          }
          cite {
            font-size: ${font.size.md[2]};
            line-height: ${lineHeight[7]};
          }
        }
        @media (min-width: ${viewport.tablet.sm}) {
          i {
            position: absolute;
            left: -40px;
          }

          h2,
          article {
            padding-left: 240px;
          }
          figure {
            position: absolute;
            left: 0;
            top: 0;
          }
          img {
            margin-left: -20px;
          }
        }
      `}</style>
    </section>
  );
}
